import React, { FC, ReactNode } from "react";
import cx from "classnames";
import { CurrencyType, currencyMap } from "../../../types";
import { ActionButton } from "../../../../../Atoms/ActionButton/ActionButton";
import { dataTestIds } from "data-testids";

interface IPriceInfoBlockProps {
  value: number;
  title: ReactNode;
  variant: "primary" | "secondary";
  name?: ReactNode;
  currencySymbol?: string;
  paymentPeriod?: string;
  vatPrice?: string;
  pricePrefix?: string;
  priceSuffix?: string;
  icon?: string;
  onIconClick?: (
    event:
      | React.MouseEvent<HTMLAnchorElement>
      | React.KeyboardEvent<HTMLAnchorElement>
  ) => void;
}

const infoBoxesClassNames =
  "flex gap-2 md:items-center justify-between rounded-md flex-col md:flex-row";

const PriceInfoBlock: FC<IPriceInfoBlockProps> = ({
  name,
  currencySymbol = currencyMap[CurrencyType.GBP],
  value,
  title,
  paymentPeriod,
  variant,
  vatPrice,
  pricePrefix,
  priceSuffix,
  icon,
  onIconClick,
}) => {
  return (
    <div
      className={cx(infoBoxesClassNames, {
        "bg-color-brand-two text-white p-4": variant === "primary",
        "bg-color-neutral-four py-2 px-4": variant === "secondary",
      })}
      data-testid={
        dataTestIds.componentLibrary[
          "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PlanDetail"
        ]
      }
    >
      <div className="flex flex-col items-start gap-1">
        <p className="self-start md:text-[22px] font-secondary">{title}</p>
        {name && <p className="text-lg">{name}</p>}
      </div>
      <div className="flex items-center gap-3">
        <div className="flex flex-col gap-1 md:items-center">
          <p
            className={cx("text-lg", {
              "md:text-[26px]": variant === "primary",
              "md:text-[22px] md:leading-none": variant === "secondary",
            })}
            data-testid={
              dataTestIds.componentLibrary[
                "Organisams.Billing.AddOnCheckout.PriceInfoBlock.PriceDetail"
              ]
            }
          >
            {pricePrefix} {currencySymbol}
            {value.toFixed(2)} {priceSuffix} {paymentPeriod}
          </p>
          {vatPrice && (
            <div
              className={cx("text-m whitespace-nowrap", {
                "text-white": variant === "primary",
                "text-color-neutral-one": variant === "secondary",
              })}
            >
              {vatPrice}
            </div>
          )}
        </div>
        {icon && onIconClick && (
          <ActionButton icon={icon} onClick={onIconClick} size="small" />
        )}
      </div>
    </div>
  );
};

export default PriceInfoBlock;
